<template>
  <div class="col-12 xl:col-10 mx-auto">
    <template v-if="!request">
      <div v-if="!uniqueSiteMode">
        <SiteSelectionComponent
          v-model="selectedSite"
          :sites="sites"
          @change="onSiteChanged"
        />
      </div>
      <div v-else>
        <UniqueSiteInformations
          :unique-site="selectedSite"
        />
      </div>

      <div v-if="selectedSite">
        <h2>
          {{ $t('appointmentPage.appointments.sectionTitle') }}
        </h2>
        <h3 class="mt-0 mb-2">
          {{ $t('sitesection.site.title') }}
        </h3>
        <h4><strong>{{ selectedSite.name }}</strong></h4>
        <h4><strong>{{ selectedSite.address.name }}</strong></h4>
        <h4><strong>{{ selectedSite.address.postcode }} {{ selectedSite.address.city }}</strong></h4>
        <div class="flex">
          <i class="pi pi-phone align-self-center"/>
          <h4 class="ml-3">
            {{ formatPhoneNumberAsInternational(selectedSite.phoneNumber, selectedSite.phoneNumberCountryCode) }}
          </h4>
        </div>
        <p class="text-justify">
          {{ $i18n.locale === 'fr' ? selectedSite.frenchDescription : selectedSite.englishDescription }}
        </p>
      </div>
      <EquipmentNumberForm
        v-if="selectedSite"
        v-model="equipmentsNumber"
        :is-special-request="isSpecialRequest"
        @duration-changed="onDurationUpdate($event)"
      />

      <div v-if="totalDuration > 0 && selectedSite">
        <special-request-form
          v-if="isSpecialRequest && checkIsContactUser"
          :user="user"
          :stakeholder="stakeholder"
          :nb-equipments="equipmentsNumber"
          :site="selectedSite"
        />
        <template v-else>
          <request-remaining-duration
            :appointments="appointments"
            :control-duration="totalDuration"
            :is-special-request="isSpecialRequest"
            @duration-updated="checkValueReceived($event)"
          />

          <p>{{ $t('appointmentPage.appointments.selectInstruction') }}</p>

          <OfficeCalendarsTabView
            v-model="appointments"
            :site="selectedSite"
            :control-duration="totalDuration"
          />

          <request-appointments
            v-if="user"
            v-model:appointments="appointments"
            :control-duration="totalDuration"
            :stakeholder="stakeholder"
            :user="user"
            :equipments-number="equipmentsNumber"
            @booked="onBooked"
          />
        </template>
      </div>
    </template>
    <request-recap
      v-else
      :request="request"
      :equipment-quantity="equipmentsNumber"
      :selected-site="selectedSite"
      :stakeholder="stakeholder"
      :appointments="appointments"
      @on-preview="onPreview"
    />
  </div>
</template>

<script>
import SiteSelectionComponent from "@/components/map/SiteSelectionComponent";
import OfficeCalendarsTabView from "@/components/appointments/OfficeCalendarsTabView";
import RequestAppointments from "@/components/appointments/RequestAppointments";
import EquipmentNumberForm from "@/components/EquipmentNumberForm";
import RequestRemainingDuration from "@/components/appointments/RequestRemainingDuration";
import RequestRecap from "@/components/appointments/RequestRecap";
import SpecialRequestForm from "@/components/specialrequest/SpecialRequestForm.vue";
import UniqueSiteInformations from "@/components/appointments/UniqueSiteInformations";
import {CONTACT_ROLE} from "@/shared/constants";
import {reactive} from "vue";
import useSiteFilter from "@/composables/filters/useSiteFilter";
import {formatPhoneNumberAsInternational} from "@/shared/utils/phoneNumberUtils";

export default {
  name: 'CreateRequestView',
  components: {
    RequestRecap,
    SpecialRequestForm,
    SiteSelectionComponent,
    EquipmentNumberForm,
    RequestRemainingDuration,
    OfficeCalendarsTabView,
    RequestAppointments,
    UniqueSiteInformations
  },
  setup() {
    const siteFilter = reactive(useSiteFilter());
    siteFilter.filters.enabled.value = true;
    return { siteFilter };
  },
  data() {
    return {
      sites: [],
      selectedSite: null,
      offices: [],
      selectedOffice: null,
      equipmentsNumber: 0,
      totalDuration: 0,
      appointments: [],
      user: null,
      stakeholder: null,
      request: null,
      uniqueSiteMode: false,
      isSpecialRequestCurrent: false,
      tokenSpecialRequest: false,
    }
  },
  computed: {
    getSpecialRequestTime() {
      return this.$store.getters['setting/getSpecialRequestTime'];
    },
    isSpecialRequest() {
      if(this.tokenSpecialRequest){
        const isSpecialRequest = this.totalDuration >= this.getSpecialRequestTime;
        this.updateLocalInformation(isSpecialRequest);
      }
      return this.isSpecialRequestCurrent;
    },
    checkIsContactUser(){
      return this.$store.state.auth.user.role === CONTACT_ROLE;
    },
    uniqueSiteCode() {
      return this.$store.getters["setting/getUniqueSiteCode"];
    },
  },
  async mounted() {
    this.$emitter.on('book-failed', () => this.appointments = [])
    this.sites = (await this.$siteService.fetchSitesPagingAndSorting(this.siteFilter.getQueryParams())).content;

    if(this.uniqueSiteCode) {
      this.selectedSite = this.sites.find(site => { return site.code === this.uniqueSiteCode });
      this.uniqueSiteMode = true
    }

    const userId = this.$route.params.userId
    if (userId) {
      this.user = await this.$userService.fetchUser(userId)
    } else {
      this.user = await this.$store.state.auth.user
    }
    this.stakeholder = this.user.stakeholder
  },
  methods: {
    formatPhoneNumberAsInternational,
    onSiteChanged() {
      this.appointments = []
    },
    onBooked(request) {
      this.request = request
    },
    onPreview() {
      this.request = null
      this.totalDuration = 0
      this.appointments = []
    },
    onDurationUpdate(duration) {
      this.tokenSpecialRequest = true;
      this.totalDuration = duration;
    },
    checkValueReceived(value){
      this.totalDuration = value;
      return true;
    },
    updateLocalInformation(isSpecialRequest){
       this.isSpecialRequestCurrent = isSpecialRequest;
       this.tokenSpecialRequest = false;
    },
  }
}
</script>

<style lang="scss" scoped>
h3 {
  font-family: 'Poppins', sans-serif;
  color: $blue;
  font-weight: normal;
}

h4 {
  font-weight: 400;
  color: black;
  margin: 0;
  padding: 0.2rem
}
</style>
